import React, { Component } from 'react';
import Avatar from 'react-avatar';
import './MinMainPnl.css';
import profilee from '../../../images/public/userarea/profilee.png';

import crdscia from '../../../images/public/userarea/crdscia.png';
import crdscis from '../../../images/public/userarea/crdscis.png';
import crdscij from '../../../images/public/userarea/crdscij.png';
import crdscib from '../../../images/public/userarea/crdscib.png';
import crdsciblock from '../../../images/public/userarea/crdsciblock.png';

import crdpagana from '../../../images/public/userarea/crdpagana.png';
import crdpaganj from '../../../images/public/userarea/crdpaganj.png';
import crdpaganb from '../../../images/public/userarea/crdpaganb.png';

import dualSeniorActive from '../../../images/public/userarea/dualSeniorActive.png';
import dualAdultActive from '../../../images/public/userarea/dualAdultActive.png';
import dualJuniorActive from '../../../images/public/userarea/dualJuniorActive.png';
import dualBabyActive from '../../../images/public/userarea/dualBabyActive.png';

import dualSeniorBlock from '../../../images/public/userarea/dualSeniorBlock.png';
import dualAdultBlock from '../../../images/public/userarea/dualAdultBlock.png';
import dualJuniorBlock from '../../../images/public/userarea/dualJuniorBlock.png';
import dualBabyBlock from '../../../images/public/userarea/dualBabyBlock.png';


import alertb from '../../../images/public/userarea/alertb.png';
import { getSkiers } from '../../../libs/fetch';

class MinMainPnl extends Component {

		constructor(props) {
				super(props);

				this.state = {
						// Activemin: props.Active, // card not active
						// Blockmin: props.Block, // disabled card
						// Activatemin : props.Activate, // card must be activated
						// Alert: props.Alert, //show alert badge if disabled or not active
						user: this.props.user,
						userPic: (this.props.user.length < 2) ? this.props.user[0].picture : (this.props.user[0].picture ? this.props.user[0].picture : this.props.user[1].picture),
						iconClass: "responsiveCardmin",
				};

				console.log('SKIERS PROPS', this.state.user);
				// console.log('SKIERS STATE', this.state);
				//console.log('SKIER',this.props.user);

				this.onClick = this.onClick.bind(this);
        this.isAmbassador();
      }
    
      isAmbassador = () => {
        getSkiers(this, { email: this.state.user.email, backoffice: 0 }).then((response) => {
          response.forEach(skier => {
              if (skier.id === this.state.user[0].id && skier.portale === 'ambassadorsci') {
                this.setState({isAmbassador: true});
              }
          });
        });
        return false;
      }
      
    
      componentDidMount() {
        this.isAmbassador();
				this.setState({
						iconClass: this.isActive() ? "img-fluid" : "img-fluid grayScale"
				})
				
		}


		onClick = () => {

				this.props.onClick(this.props.index);
		}

		// set Expired props for skier
		// check if card has expired
		isExpired = (item) => {
				if (!(item.code == '' || item.type == null)) {
						let today = new Date();
						let expiration = new Date(item.data_scadenza);
						console.log('ACTIVE: ' + item.id + ' isExpired', (today.getTime() > expiration.getTime()))
						return (today.getTime() > expiration.getTime());
				} else {
						return false
				}
		}


		// set Block props for user
		isBlocked = (item) => {
				return (!!item.card_blocked || !!item.ticket_blocked);
		}

		// set Activate prop 
		toActivate = (item) => {
				return (item.code == '' || item.type == null);
		}

		// check id skier must upload documents
		mustUpload = (item) => {
				return !((item.certified == "1") || this.isAdult(item))
		}

		// check id skier must upload documents
		isAdult = (item) => {
				return (item.type.toLowerCase() == 'adult')
		}


		// check if Skier must show alert
		// Block  || Upload || Expired || Activate
		hasSkierAlert = () => {
				//TODO:if there is alert in atleast 1 card      
				let item = this.state.user;
				if (item.length > 1) {
						return (
								(item[0].code == '' || item[0].type == null) ||
								(!!item[0].card_blocked || !!item[0].ticket_blocked) ||
								this.isExpired(item[0]) ||
								this.mustUpload(item[0]) ||
								(item[1].code == '' || item[1].type == null) ||
								(!!item[1].card_blocked || !!item[1].ticket_blocked) ||
								this.isExpired(item[1]) ||
								this.mustUpload(item[1])
						);
				}
				return (
						(item[0].code == '' || item[0].type == null) ||
						(!!item[0].card_blocked || !!item[0].ticket_blocked) ||
						this.isExpired(item[0]) ||
						this.mustUpload(item[0])
				);

				/*         return (
										this.isActivate() ||
										this.isBlocked() ||
										this.isExpired() ||
										this.mustUpload()
								); */
		}

		// check if card isActive
		// !Block || !Activate
		isActive = () => {
				///TODO:if atleast 1 skicard is active
				let item = this.state.user;
				if (item.length > 1) {
						return (
								!((this.toActivate(item[0]) || this.isBlocked(item[0])) && (this.toActivate(item[1]) || this.isBlocked(item[1])))
						);
				}
				return (
						!(this.toActivate(item[0]) || this.isBlocked(item[0]))
				);
		}

		// Upload={this.mustUpload(item[0])}
		// Active={this.isActive(item[0])}
		// Activate={this.isActivate(item[0])}
		// Paganella={false} // @ali @amid when paganella is active?
		// Alert={this.hasSkierAlert(item[0])}
		// Block={this.isBlocked(item[0])}
		render() {
			return (
        <div>
        {
          this.state.isAmbassador &&
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', zIndex: 100 }} className='row'>
            <img style={{ width: 30, height: 40, position: 'absolute', zIndex: 100, right: 30 }} src={require('../../../images/public/ambassador/etichettaAmbassador.png')} />
          </div>
        }
				<div className="mainPnlmin p-3 d-flex align-items-center">
					<div className="container-fluid">
						<div className="row">
							<div className="col-auto">
								<div className="sn_card_profile_wrap">
									{/* {this.isActive() ? */}
									<div className="cardTypemin">
									{
										this.state.user.length == 1 ?
										<img
											src=
											{
												this.state.user[0].provider == "skidata" ?
												this.state.user[0].type == "Junior" ? crdscij : this.state.user[0].type == "Adult" ? crdscia : this.state.user[0].type == "Senior" ? crdscis : crdscib
												:
												this.state.user[0].type == "Junior" ? crdpaganj : this.state.user[0].type == "Baby" ? crdpaganb : crdpagana
											}
											className={this.state.iconClass} />
											:
											<img
												src=
												{
													this.state.user[0].type == "Junior" ? dualJuniorActive : this.state.user[0].type == "Adult" ? dualAdultActive : this.state.user[0].type == "Senior" ? dualSeniorActive : dualBabyActive
												}
												className={this.state.iconClass} />
									}
									</div>
									{/* : null } */}
									{/*
											@amid added Activate state in this panel, 
											according to pdf flow if card is not activated we show gray card 
									*/}
									{/* {!this.isActive() ?
											<div className="cardTypebmin" style={{ flex: 1 }}>
													<img src={crdsciblock} className="responsiveCardbmin" />
											</div> : null
									} */}
									<div className="profilemin">
										<img src={this.state.userPic ? this.state.userPic : profilee} className="respProfilemin" />
										{/* <Avatar src={this.state.userPic ? this.state.userPic : profilee} className="responsiveProfilemin" size={'100%'} round="50%" /> */}
									</div>
								</div>
							</div>

					<div className="col d-flex align-items-center">
						<div className="fullNamemin flex-grow-1">
							{this.state.user[0].name + ' ' + this.state.user[0].surname}
						</div>
				
					</div>
					<div className="col d-flex align-items-center justify-content-end">
					{this.hasSkierAlert() ?
								<div className="alertbmin">
										<img src={alertb} className="img-fluid" />
								</div> : null
						}
						<button className="maximizeBtn" onClick={this.onClick}></button>
					</div>
				</div>
			</div> 
		</div>
    </div>
		);
	}
}

export default MinMainPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/MinMainPnl.js